import React from 'react';
import { connect } from 'react-redux';
import MainPage from './MainPage';
import { fetchAmazing, fetchAmazingProgress, resetAmazingProgress } from '../../actions';

const moment = require('moment');

class AmazingRace5ProgressPage extends React.Component {
    componentDidMount() {
        this.props.fetch();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        const {
            amazing,
            amazingProgress,
            // ...rest
        } = this.props;
        let data = [];
        if (amazing.stages && amazing.requirements) {
            data = amazing.stages.map(stage => {
                return {
                    ...stage,
                    requirements: {
                        required: amazing.requirements.filter(({Stage, Required}) => Stage === stage.Stage && (Required === true || Required === 1)),
                        bonus: amazing.requirements.filter(({Stage, Required}) => Stage === stage.Stage && (Required === false || Required === 0)),
                    }
                };
            });
        }

        let currentStage = 1;
        let currentPoints = 0;
        if (amazingProgress.stages) {
            for (const stage of amazingProgress.stages) {
                const {
                    Stage,
                    Completed,
                    Points,
                    BonusCompleted,
                    BonusPoints,
                } = stage;
                if (Completed === 1 || Completed === true) {
                    currentPoints += Points;
                    if (BonusCompleted === 1 || BonusCompleted === true) {
                        currentPoints += BonusPoints;
                    }
                    continue;
                }
                currentStage = Stage;
                break;
            }
        }
        return (
            <MainPage title="Amazing Race 5">
                <section className="amazing-race-5-route">
                    <div className="map-path">
                        <img style={{
                            width: '1200px',
                            height: '1000px',
                            border: 0,
                        }} id="mapAmazingRace5" src="https://cdn.mgfriends.com/amazing/amazing-race-5-route.png" useMap="#mapAR5" alt="Amazing Race" />
                    </div>
                    <map id="ar5_map" name="mapAR5">
                        <area name="cp4" shape="poly"
                            coords="247,220,286,220,283,236,277,236,277,262,271,262,271,268,321,268,321,262,316,263,316,236,310,236,307,220,357,220,353,235,361,237,367,240,374,243,382,247,385,247,385,295,201,295,237,236,240,237,242,237,240,230"
                            href="#" alt="Finish" title="Finish" />
    
                        <area name="stage4" shape="poly"
                            coords="766,314,771,312,778,311,787,311,794,313,797,315,801,318,804,323,804,328,803,332,799,337,796,339,790,342,784,344,777,345,769,344,761,340,756,334,755,331,756,324,759,320,764,315"
                            href="#" alt="Stage 4" title="Stage 4" />
    
                        <area name="stage3" shape="poly"
                            coords="178,557,187,557,195,559,199,561,202,565,204,568,205,571,204,575,203,579,201,581,198,584,193,587,189,589,185,590,179,591,175,591,169,590,165,589,160,584,157,579,157,576,157,571,160,567,164,563,168,561,172,559"
                            href="#" alt="Stage 3" title="Stage 3" />
    
                        <area name="stage2" shape="poly"
                            coords="1020,514,1028,515,1034,517,1037,519,1040,522,1042,525,1043,528,1043,531,1042,534,1039,539,1036,542,1032,545,1028,547,1023,548,1010,548,1004,547,999,544,996,540,994,535,994,530,998,524,1004,519,1012,515"
                            href="#" alt="Stage 2" title="Stage 2" />
    
                        <area name="stage1" shape="poly"
                            coords="219,742,231,742,236,743,240,745,243,747,245,750,247,754,247,758,245,763,242,767,238,770,232,774,226,775,221,776,213,776,208,774,202,770,198,763,198,757,201,751,207,746,213,743"
                            href="#" alt="Stage 1" title="Stage 1" />
    
                        <area name="hongkong" shape="poly"
                            coords="388,249,389,295,401,292,416,290,434,289,500,288,512,289,527,291,529,287,531,284,533,282,536,282,538,284,540,286,541,287,591,246,586,242,585,240,573,237,557,234,544,232,527,230,512,229,496,228,453,228,436,229,423,230,411,231,400,233,399,239,398,244,398,249,390,249"
                            href="#" alt="Hong Kong" title="Hong Kong" />
    
                        <area name="vietnam" shape="poly"
                            coords="545,290,599,246,609,246,627,248,639,250,648,252,656,254,665,257,673,260,681,264,689,269,695,274,700,279,704,283,708,289,711,296,713,303,715,313,715,324,713,334,711,342,708,349,705,356,702,361,697,360,695,360,694,362,696,363,697,364,697,365,698,366,699,366,698,368,693,369,690,370,688,371,688,373,689,373,691,373,691,374,690,374,687,374,686,374,686,376,687,376,688,377,686,378,685,379,686,380,687,380,688,380,687,381,686,382,686,383,688,384,687,385,625,341,630,335,633,330,635,324,635,318,632,312,627,306,622,303,613,299,605,297,596,295,586,293,577,292,577,289,574,288,571,289,569,290,568,291,566,291,564,288,561,288,559,288,558,289,557,290"
                            href="#" alt="Vietnam" title="Vietnam" />
    
                        <area name="bandung" shape="poly"
                            coords="460,380,487,380,509,379,522,378,534,376,545,374,554,372,562,370,569,368,575,366,581,364,587,362,594,359,601,356,610,352,617,348,620,346,621,346,682,389,677,393,673,396,670,398,665,401,660,404,654,407,650,409,643,412,636,415,631,417,625,419,620,421,614,423,608,425,601,427,594,429,587,431,580,433,575,434,567,436,561,437,556,438,550,439,545,440,539,441,534,442,528,443,522,444,516,445,509,446,500,447,499,447,460,381,460,380"
                            href="#" alt="Bandung" title="Bandung" />
    
                        <area name="cp3" shape="poly"
                            coords="383,366,398,367,401,368,404,369,407,370,410,371,414,372,419,372,424,372,430,372,434,372,437,372,440,373,442,375,442,376,444,376,445,372,446,371,493,441,415,436"
                            href="#" alt="Check Point 3" title="Check Point 3" />
    
                        <area name="philippines" shape="poly"
                            coords="139,432,141,427,143,424,145,421,148,417,151,414,155,410,158,407,164,402,169,398,173,395,178,392,184,389,190,386,196,383,203,380,209,378,215,376,226,373,234,371,240,370,245,369,251,368,259,367,266,366,278,365,293,364,320,364,337,365,352,366,364,367,379,369,410,437,393,435,382,434,380,434,377,432,374,431,371,431,369,432,368,432,344,431,333,431,333,427,335,426,330,425,332,423,328,421,328,418,322,418,321,415,319,418,314,413,313,419,308,418,310,424,303,421,308,428,304,430,304,431,290,431,288,431,289,427,282,429,281,423,276,428,269,420,267,430,260,428,262,436,253,433,256,441,252,444,249,447,246,451,243,457"
                            href="#" alt="Philippines" title="Philippines" />
    
                        <area name="surabaya" shape="poly"
                            coords="139,438,240,464,243,469,246,473,249,476,252,479,256,482,260,485,265,488,272,491,279,494,286,496,292,498,300,500,315,503,327,505,339,506,358,508,419,509,353,561,332,560,311,558,295,556,277,553,260,550,240,545,228,541,215,536,208,533,198,528,190,523,184,519,175,513,167,506,160,499,149,484,143,470,139,456,138,445"
                            href="#" alt="Surabaya" title="Surabaya" />
    
                        <area name="bali" shape="poly"
                            coords="429,509,436,508,442,507,449,506,457,505,466,504,475,503,488,502,503,501,526,501,564,501,577,502,590,503,601,504,614,506,626,508,636,510,649,513,654,515,584,568,573,566,560,564,546,562,533,561,507,559,491,558,467,557,427,557,403,558,386,559,373,560,360,562"
                            href="#" alt="Bali" title="Bali" />
    
                        <area name="cp2" shape="poly" coords="660,520,748,522,748,524,688,568,683,560,676,570,595,570" href="#"
                            alt="Check Point 2" title="Check Point 2" />
    
                        <area name="malaysia" shape="poly"
                            coords="694,577,751,528,809,529,825,530,840,531,852,532,862,533,871,534,879,535,888,536,895,537,901,538,908,539,912,540,918,541,924,542,929,543,934,544,939,545,943,546,963,551,981,556,973,560,967,553,963,552,965,555,960,555,960,557,962,558,961,559,959,559,959,561,959,562,960,562,958,563,957,564,952,565,949,567,945,570,943,571,939,570,936,569,934,570,934,571,935,572,935,573,935,574,934,574,933,575,932,576,903,588,883,585,866,583,847,581,815,579,783,578,753,577,747,577,747,574,743,578,738,572,737,578,695,579"
                            href="#" alt="Malaysia" title="Malaysia" />
    
                        <area name="medan" shape="poly"
                            coords="976,565,985,561,992,563,997,565,1002,567,1007,569,1013,572,1020,576,1026,579,1031,582,1035,585,1039,588,1043,591,1050,598,1054,602,1058,606,1061,610,1064,615,1066,619,1068,623,1070,628,1072,634,1073,640,1074,652,1074,659,1072,670,1070,676,1068,681,1066,686,1063,692,1060,697,1056,704,1053,708,1050,712,1045,719,1041,724,1037,728,1033,732,1029,736,975,698,979,694,983,690,987,686,992,680,996,674,999,667,1001,659,1001,652,1000,644,997,637,994,633,989,627,984,623,980,620,975,617,970,614,966,612,962,610,958,608,953,606,947,604,941,602,935,600,929,598,923,596,916,594,910,593,909,592,935,581,937,581,946,577,948,577,950,578,951,579,952,580,953,581,958,582,962,582,969,581,973,577,975,573,976,569,976,568,982,567"
                            href="#" alt="Medan" title="Medan" />
    
                        <area name="yogyakarta" shape="poly"
                            coords="733,710,739,711,746,712,755,713,763,714,774,715,783,716,795,717,815,718,837,718,860,718,878,718,896,717,912,715,925,713,935,711,944,709,951,707,961,704,966,702,971,700,1027,739,1023,741,1019,743,1015,745,1010,747,1002,750,997,752,991,754,985,756,979,758,972,760,964,762,956,764,949,766,943,767,934,769,927,770,920,771,915,772,906,773,897,774,889,775,879,776,870,777,857,777,794,778,783,777,769,776,758,775,748,773,747,770,750,770,750,764"
                            href="#" alt="Yogyakarta" title="Yogyakarta" />
    
                        <area name="cp1" shape="poly"
                            coords="661,694,673,694,675,694,677,695,680,696,684,697,687,697,690,697,692,697,693,697,696,697,700,698,703,698,705,698,706,699,707,699,708,700,710,700,711,701,712,701,713,700,714,698,714,697,729,698,749,764,674,762"
                            href="#" alt="Check Point 1" title="Check Point 1" />
    
                        <area name="thailand" shape="poly"
                            coords="605,683,609,684,614,685,619,686,635,690,643,692,649,694,655,696,660,698,662,699,673,762,665,759,658,757,651,755,642,753,634,751,628,750,623,749,614,747,608,746,601,745,591,743,585,742,579,741,574,740,567,739,560,738,552,737,545,736,537,735,525,734,508,733,498,671,516,672,531,673,542,674,552,675,560,676,567,677,573,678,580,679,586,680,593,681,599,682,605,683"
                            href="#" alt="Thailand" title="Thailand" />
    
                        <area name="singapore" shape="poly"
                            coords="271,789,272,781,273,777,275,771,277,766,279,762,281,758,283,754,288,746,292,740,297,734,302,728,307,723,310,720,315,716,320,712,324,709,330,705,336,701,343,697,354,692,366,687,371,685,380,682,388,680,396,678,410,675,424,673,443,671,466,670,495,670,505,732,496,732,494,727,491,724,485,722,480,723,476,725,474,727,473,729,471,729,469,728,466,728,463,729,462,730,459,728,455,728,453,730,451,732,450,734,449,735,438,737,430,739,423,741,414,744,405,748,397,752,390,756,383,761,374,769,368,777,350,779,350,775,347,774,344,776,343,779,341,777,338,778,336,779,335,776,333,774,329,775,328,777,330,779,331,781"
                            href="#" alt="Singapore" title="Singapore" />
    
                        <area name="jakarta" shape="poly"
                            coords="270,794,335,787,336,789,337,792,337,796,336,798,334,799,331,799,329,798,326,798,323,798,319,798,318,798,316,798,313,799,311,800,309,801,308,803,307,805,307,807,306,809,305,810,303,811,303,810,303,809,302,809,302,811,302,812,302,813,303,814,304,815,305,814,307,813,308,812,308,811,310,811,311,812,311,814,312,816,312,818,313,819,314,822,314,824,315,825,315,829,316,831,316,833,317,834,321,834,323,834,323,833,322,831,321,828,320,826,319,823,319,820,319,819,318,817,319,815,319,813,319,812,321,814,322,815,325,816,326,817,329,817,330,817,332,817,333,817,335,817,335,821,334,823,334,825,334,827,334,828,334,830,335,831,335,832,337,833,338,833,339,832,339,831,338,830,337,829,337,828,339,827,340,827,340,829,341,830,342,832,342,833,344,833,344,832,343,830,343,829,344,828,344,828,346,828,347,830,347,831,347,833,347,834,347,835,348,835,349,835,349,833,349,832,349,830,349,829,350,828,351,828,352,827,353,827,352,829,352,830,351,831,352,831,353,832,354,830,355,829,356,827,356,825,356,824,355,822,355,822,356,820,356,820,358,819,358,818,359,816,358,815,358,814,358,813,358,811,359,811,360,811,361,810,362,809,362,808,362,807,361,807,360,808,359,809,358,809,357,808,357,807,355,807,353,807,352,807,351,808,350,809,349,808,347,807,347,805,347,803,347,801,346,799,346,796,345,794,344,791,343,790,344,790,346,790,347,790,348,789,348,788,348,787,347,786,347,786,346,785,365,784,363,787,362,790,362,793,362,796,363,800,364,804,366,807,368,810,371,813,375,816,378,818,382,820,387,822,390,823,396,824,415,824,416,824,423,823,430,822,437,821,446,819,455,817,463,815,469,813,476,811,482,809,488,807,493,805,501,802,499,804,497,807,495,811,493,816,492,825,494,834,496,838,498,842,501,846,504,849,507,852,511,855,515,857,518,859,520,860,524,862,517,865,512,867,506,869,500,871,490,874,483,876,475,878,467,880,461,881,455,882,448,883,440,884,431,885,399,886,382,885,368,883,356,881,344,878,337,876,330,873,322,869,315,865,309,861,303,856,297,851,291,845,286,839,281,832,278,826,275,818,272,809,270,800"
                            href="#" alt="Jakarta" title="Jakarta" />
                    </map>
                </section>
                <section className="amazing-race-5-box-point">
                    <div className="ar5-infopoint">
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="box">
                                        <div className="row text-center">
                                            <ul className="divider-point">
                                                <li className="border">
                                                    <div className="title-tag">
                                                        Stage needed to be completed
                                                    </div>
                                                    <div className="point-tag">
                                                        {`Stage ${currentStage}`}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="title-tag">
                                                        Your current points
                                                    </div>
                                                    <div className="point-tag">
                                                        {`${currentPoints} POINTS`}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ar5-citiescompleted">
                        <div className="container">
                            <div className="row title">
                                <div className="col-xs-12">
                                    <h2>CITIES TO BE COMPLETED</h2>
                                </div>
                            </div>
                            <div className="row info-cities-points">
                                {
                                    amazingProgress.stages ? amazingProgress.stages.map(({Stage, requirements}, index) => (
                                        <div key={index} className="col-xs-3">
                                            <div className="stagebox">
                                                <h2>{`STAGE ${Stage}`}</h2>
                                                {
                                                    requirements.filter(({Required}) => Required === 1 || Required === true).map(({Ref, RoomNight, progress}, index) => (
                                                        <p key={index}>
                                                            <span>{Ref}</span>
                                                            <br />
                                                            {`${progress.RoomNight || 0}/${RoomNight} Room Nights`}
                                                        </p>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    )) : data.map(({Stage, requirements: {required}}, index) => (
                                        <div key={index} className="col-xs-3">
                                            <div className="stagebox">
                                                <h2>{`STAGE ${Stage}`}</h2>
                                                {
                                                    required.map(({Ref, RoomNight}, index) => (
                                                        <p key={index}>
                                                            <span>{Ref}</span>
                                                            <br />
                                                            {`0/${RoomNight} Room Nights`}
                                                        </p>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="ar5-bonusmission">
                        <div className="container">
                            <div className="box-bonusmission">
                                <div className="row title">
                                    <div className="col-xs-12">
                                        <h2>
                                            <i className="point-bullseye"></i>BONUS MISSION
                                            <span>Mission to get bonus points in each stages</span>
                                        </h2>
                                    </div>
                                </div>
                                <div className="row point-bonusmission">
                                    {
                                        amazingProgress.stages ? amazingProgress.stages.map(({Stage, BonusPoints, requirements}, index) => (
                                            <div key={index} className="col-xs-6">
                                                <div className="stage1-point-bonusmission">
                                                    <div className="title-point-bonusmission">
                                                        <h4>
                                                            {`Stage ${Stage} - Bonus ${BonusPoints} POINT`}
                                                        </h4>
                                                    </div>
                                                    {
                                                        requirements && requirements.filter(({Required}) => Required === 0 || Required === false).map(({Ref, RoomNight, progress}, index) => (
                                                            <p key={index}>
                                                                <i className="far fa-circle"></i>
                                                                <span>{Ref}</span>
                                                                {`${progress.RoomNight || 0}/${RoomNight} room nights`}
                                                            </p>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )) : data.map(({Stage, BonusPoints, requirements: {bonus}}, index) => (
                                            <div key={index} className="col-xs-6">
                                                <div className="stage1-point-bonusmission">
                                                    <div className="title-point-bonusmission">
                                                        <h4>
                                                            {`Stage ${Stage} - Bonus ${BonusPoints} POINT`}
                                                        </h4>
                                                    </div>
                                                    {
                                                        bonus.map(({Ref, RoomNight}, index) => (
                                                            <p key={index}>
                                                                <i className="far fa-circle"></i>
                                                                <span>{Ref}</span>
                                                                {`0/${RoomNight} room nights`}
                                                            </p>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="description-landing-page-1">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <h1>Rules &amp; Regulation</h1>
                            </div>
                            <div className="col-xs-12">
                                <ul>
                                    <li>
                                        Valid for All MG Friends
                                    </li>
                                    <li>
                                        Check your current position by logging in through mgfriends.com and click "Amazing Race 5"
                                        tab menu on the top right page
                                    </li>
                                    <li>
                                        In each stage, you have to book hotels in particular destination with certain numbers of
                                        room nights to collect the points
                                    </li>
                                    <li>
                                        Complete all 4 stages by booking the hotels in each cities to get more points
                                    </li>
                                    <li>
                                        The bookings unnecessarily have to be in sequence. You can make bookings in Stage 2 or 4
                                        first, then continue with the other stages. However, you are required to complete the
                                        previous Stage to collect all the points. For example, if Stage 2 is completed, you also
                                        need to complete Stage 1 to get all the points.
                                    </li>
                                    <li>
                                        Bonus Mission is available in each stage. You can get additional points if you successfully
                                        book certain numbers of room nights for particular hotel (Don't forget to check the hotel
                                        list)
                                    </li>
                                    <li>
                                        Bonus Mission Points are earned if the Stage is completed
                                    </li>
                                    <li>
                                        All points collected in each stages will go directly to your MG Friends account after the 4
                                        Stages are completed
                                    </li>
                                    <li>
                                        After completing each stage, be noted to log-in at mgfriends.com and click the "Amazing Race
                                        5" menu on the top right page to automatically add your points
                                    </li>
                                    <li>
                                        Make sure to log-in to your account frequently to check on your progress
                                    </li>
                                    <li>
                                        Bonus Mission Points are earned if the Stage is completed
                                    </li>
                                    <li>
                                        Room nights to be collected in each stage:
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="box-stage-amazing-race-5">
                    <div className="container">
                        <div className="row">
                            {
                                data.map(({Stage, Points, BonusPoints, requirements: {required, bonus}}, index) => (
                                    <div key={index} className="col-xs-6">
                                        <div className="box-stage">
                                            <h2>{`STAGE ${Stage}`}</h2>
                                            <div className="stage-total-point">
                                                <p>{`Total ${Points} Points`}</p>
                                            </div>
                                            <table>
                                                <tbody>
                                                    {
                                                        required.map(({Ref, RoomNight}, index) => (
                                                            <tr key={index}>
                                                                <td><i className="far fa-circle"></i></td>
                                                                <td>{Ref}</td>
                                                                <td>{`(Collect ${RoomNight} room nights at any hotels)`}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {
                                            bonus.length > 0 &&
                                            (
                                                <div className="box-bonus">
                                                    <h2><i className="point-bullseye"></i>Bonus Mission</h2>
                                                    <p className="book-all">{`(Book all, get +${BonusPoints} points)`}</p>
                                                    {
                                                        bonus.map(({Ref, RoomNight}, index) => (
                                                            <p key={index}><i className="far fa-circle"></i>{`${Ref} ${RoomNight} room nights`}</p>
                                                        ))
                                                    }
                                                </div>
                                            )
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </section>
                <section className="description-landing-page-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <h1>Terms &amp; Conditions</h1>
                            </div>
                            <div className="col-xs-12">
                                <ul>
                                    <li>
                                        {`Booking period and check in / out ${moment(amazing.Start).format('MMM, DD YYYY')} - ${moment(amazing.End).format('MMM, DD YYYY')}`}
                                    </li>
                                    <li>
                                        Amazing Race Points are not similar with Regular Points or MGF Xtra Points (if any)
                                    </li>
                                    <li>
                                        Amazing Race Points are only apply for MG Friends Members
                                    </li>
                                    <li>
                                        Haven't registered yet? Go to mgfriends.com and join us!
                                    </li>
                                    <li>
                                        All 3 winners who completed all stage will be announced in MG Social Media and Newsletter
                                    </li>
                                    <li>
                                        More info, click mgfriends.com/amazing-race
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </MainPage>
        );
    }
}

AmazingRace5ProgressPage.defaultProps = {
    amazingProgress: {
        stages: [],
    },
};

const mapStateToProps = state => {
    return {
        amazing: state.amazing,
        amazingProgress: state.amazingProgress,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        fetch: async () => {
            try {
                await dispatch(fetchAmazing());
                await dispatch(fetchAmazingProgress());
            } catch (error) {
                throw error;
            }
        },
        reset: async () => {
            try {
                await dispatch(resetAmazingProgress());
            } catch (error) {
                throw error;
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AmazingRace5ProgressPage);